/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OperationPostureCloudProvider {
    getFixupPrototypeFunction() { return OperationPostureCloudProvider.fixupPrototype; }

    static newInstance(model: Partial<OperationPostureCloudProvider>): OperationPostureCloudProvider {
        let obj = Object.assign(new OperationPostureCloudProvider(), model);
        OperationPostureCloudProvider.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OperationPostureCloudProvider>): OperationPostureCloudProvider {
        if (!model) return null;
        return OperationPostureCloudProvider.newInstance(<OperationPostureCloudProvider> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OperationPostureCloudProvider) {
        if (!obj) return;

        models.OperationPostureCloudProvider.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OperationPostureCloudProvider): boolean {
        Object.setPrototypeOf(obj, OperationPostureCloudProvider.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.alerts) {
            models.OperationPostureCloudCounts.fixupPrototype(this.alerts);
        }
        if (this.activities) {
            models.OperationPostureCloudCounts.fixupPrototype(this.activities);
        }
        if (this.automation_failures) {
            models.OperationPostureCloudCounts.fixupPrototype(this.automation_failures);
        }
    }

    /**
     * alerts count
     */
    alerts: models.OperationPostureCloudCounts;

    /**
     * activities cost
     */
    activities: models.OperationPostureCloudCounts;

    /**
     * automation count
     */
    automation_failures: models.OperationPostureCloudCounts;

}
